import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { PrinterFetchAPI } from '../../../api/Printer';
import { Badge } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { CategriesPosFetchAPI } from '../../../api/Paymentpost/CategoriesPos';
import './ModalEditIp.css'
const ModalAddCategories = ({ printer }) => {
    const [showAddModalCategories, setShowAddModalCategories] = useState(false)
    const [categories, setCategories] = useState([])
    const [selectCategorie, setSelectCategorie] = useState({ categorie: "" })
    let branchoffice = localStorage.getItem('branchoffice');
    let business = localStorage.getItem('business')
    let token = localStorage.getItem('x-access-machine-token');

    //We validate if the branch
    if (branchoffice !== null && branchoffice !== undefined && branchoffice !== '') {
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    }

    if (business !== null && business !== undefined && business !== '') {
        business = JSON.parse(localStorage.getItem('business'))
    }

    //function get categories by brach office and by status
    const getCategoriesByBusiness = async () => {
        try {
            const response = await CategriesPosFetchAPI.getCategoriesByBusiness(business.id, token);
            console.log(response.data.data);
            setCategories(response.data.data)
        } catch (error) {

            console.log(error);
        }
    }

    const viewCategories = () => {
        const listCategories = categories.map((categorie) => (
            <>
                <option value={JSON.stringify(categorie)}>{categorie.category_name}</option>
            </>
        ));

        return (listCategories)
    }

    const handle = (e) => {
        setSelectCategorie(JSON.parse(e.target.value))
    }

    const addCategorie = async () => {
        try {
            let data = {
                "category_id": selectCategorie.category_id,
                "printer_id": printer.printer_id
            }
            const response = await CategriesPosFetchAPI.addCategories(data, token)
            ErrorAlert("Registro de categoria exitoso", "Realizado", "success")
            setShowAddModalCategories(false)
            console.log(response);
        } catch (err) {

            if (err.response.data.error == "Impresora y categoria ya asignados") {
                ErrorAlert("", "Categoria ya asignados", "error")
            } else {
                ErrorAlert("", "Error al registrar", "error")
            }

            console.log(err);
        }
    }




    return (
        <>
            <button className="sp-cfg__btn sp-cfg__btn--primary mt-2" onClick={() => (getCategoriesByBusiness(), setShowAddModalCategories(true))}>
                <i className="uil uil-book-medical"></i> Agregar categorias
            </button>

            <Modal
                show={showAddModalCategories}
                onHide={() => setShowAddModalCategories(false)}
                centered
                size="sm-down"
            >
                <Modal.Body className="sp-cfgmini rounded-4">
                    <div className="sp-cfgmini__head">
                        <div className="sp-cfg__badge sp-cfg__badge--sm"><i className="uil uil-print"></i></div>
                        <h5 className="sp-cfgmini__title">{printer.printer_name}</h5>
                        <button className="sp-cfg__x" type="button" aria-label="Cerrar" onClick={() => setShowAddModalCategories(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <h3 className="sp-eip__subtitle"><i className="uil uil-book-medical"></i> Agregar nueva categoria</h3>

                    <div className="sp-cfgmini__field">
                        <label className="sp-cfg__label">Categoría:</label>
                        <select className="sp-cfg__select" onChange={(e) => (handle(e))}>
                            <option>Seleccione una categoria</option>
                            {viewCategories()}
                        </select>
                    </div>

                    <div className="sp-cfgmini__acts sp-cfgmini__acts--split">
                        <button className="sp-cfg__btn sp-cfg__btn--danger" onClick={() => setShowAddModalCategories(false)}>Cancelar</button>
                        <button className="sp-cfg__btn sp-cfg__btn--ok" onClick={async () => (addCategorie())}>Guardar</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalAddCategories